<div [formGroup]="formGroup" class="row-container">
  <div class="row">
    <div class="item">
      <app-input
        [autofocus]="!isEditing()"
        enableViewMode
        formControlName="purchaseOrderId"
        [label]="translations.purchaseOrderIdLabel"
        suffixIcon="autorenew"
        [suffixIconTp]="translations.suffixIconTp"
        (suffixIconPressed)="generateItemNumber()"
      ></app-input>
    </div>
    @if (element()) {
      <div class="row">
        <div class="item">
          <app-input-select
            [options]="statusOtions"
            enableViewMode
            formControlName="status"
            [label]="translations.status"
          ></app-input-select>
        </div>
      </div>
    }
    <div class="row">
      <div class="item">
        <app-datepicker
          enableViewMode
          formControlName="orderDate"
          [label]="translations.orderDate"
        ></app-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <app-datepicker
          enableViewMode
          formControlName="expectedDeliveryDate"
          [label]="translations.deliveryDate"
        ></app-datepicker>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <app-input-select
          [options]="organisationsOptions()"
          enableViewMode
          [viewModeTemplate]="organisationViewMode"
          formControlName="supplier"
          [label]="translations.supplierOrg"
        >
          <ng-container action>
            <app-button
              (pressed)="onAddOrganisationClicked('supplier')"
              class="icon-add-circle"
              [tp]="translations.organisationTp"
              type="icon"
            >
              <mat-icon icon-small>add</mat-icon>
            </app-button>
          </ng-container>
        </app-input-select>
        @if (!formGroup.controls["supplier"].value) {
          <ng-container
            *ngTemplateOutlet="selectOrgLink; context: { $implicit: 'supplier' }"
          ></ng-container>
        }
      </div>
    </div>
    <div class="row">
      <div class="item">
        <app-input-select
          [options]="organisationsOptions()"
          enableViewMode
          [viewModeTemplate]="organisationViewMode"
          formControlName="buyer"
          [label]="translations.buyerOrg"
        >
          <ng-container action>
            <app-button
              (pressed)="onAddOrganisationClicked('buyer')"
              class="icon-add-circle"
              [tp]="translations.organisationTp"
              type="icon"
            >
              <mat-icon icon-small>add</mat-icon>
            </app-button>
          </ng-container>
        </app-input-select>
        @if (!formGroup.controls["buyer"].value) {
          <ng-container
            *ngTemplateOutlet="selectOrgLink; context: { $implicit: 'buyer' }"
          ></ng-container>
        }
      </div>
    </div>
    <div class="row">
      <div class="item">
        <app-input-select
          [options]="locationsOptions()"
          enableViewMode
          [viewModeTemplate]="locationViewTemplate"
          formControlName="deliverToLocation"
          [label]="translations.deliverToLocation"
        >
          <ng-container action>
            <app-button
              (pressed)="onAddLocationClicked()"
              class="icon-add-circle"
              [tp]="translations.locationTp"
              type="icon"
            >
              <mat-icon icon-small>add</mat-icon>
            </app-button>
          </ng-container>
        </app-input-select>
      </div>
    </div>
    <div class="row">
      <div class="item">
        <app-input enableViewMode formControlName="note" [label]="translations.note"></app-input>
      </div>
    </div>
  </div>
</div>
<ng-template #organisationViewMode let-label="label" let-option>
  <div class="form-field-item">
    <app-form-label [label]="label"></app-form-label>
    <div class="form-field-input-readonly">
      @if (option.label && option.value) {
        <app-form-link [link]="getOrganisationLink(option.value)" [styledLink]="true">
          {{ option.label }}
        </app-form-link>
      } @else {
        <app-loader containerClass="size-small"></app-loader>
      }
    </div>
  </div>
</ng-template>

<ng-template #locationViewTemplate let-label="label" let-option>
  <div class="form-field-item">
    <app-form-label [label]="label"></app-form-label>
    <div class="form-field-input-readonly">
      @if (option.label && option.value) {
        <app-form-link [link]="getLocationLink(option.value)" [styledLink]="true">
          {{ option.label }}
        </app-form-link>
      } @else {
        -
      }
    </div>
  </div>
</ng-template>
<ng-template #selectOrgLink let-type>
  <div class="blue-link clickable select-organisation-container" (click)="selectOrganisation(type)">
    {{ translations.selectMyOrgTxt }} ({{ activeOrganisationOption().label }})
  </div>
</ng-template>
